var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('Area',_vm._g({attrs:{"width":"1473"}},_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }